// DS: i3.35
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const FirstPage: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M7.89836 7C7.89836 6.44772 7.48348 6 6.9717 6C6.45992 6 6.04504 6.44772 6.04504 7V17C6.04504 17.5523 6.45992 18 6.9717 18C7.48348 18 7.89836 17.5523 7.89836 17L7.89836 7Z" />
        <path d="M11.7837 11.2426L16.3705 6.29289C16.7324 5.90237 17.3191 5.90237 17.681 6.29289C18.0428 6.68342 18.0428 7.31658 17.681 7.70711L13.75 11.949L17.681 16.1924C18.0428 16.5829 18.0428 17.2161 17.681 17.6066C17.3191 17.9971 16.7324 17.9971 16.3705 17.6066L11.7837 12.6569C11.4219 12.2663 11.4219 11.6332 11.7837 11.2426Z" />
      </svg>
    </IconWrap>
  );
};
FirstPage.displayName = 'FirstPage';

export default FirstPage;
